import { useContext } from 'react'
import { LiquidiumContext } from '../providers/LiquidiumProvider'

export default function useLiquidium() {
  return useContext(LiquidiumContext)
}
